import {
  useBeeswaxAdPosition,
  useBeeswaxEnvironmentTypes,
} from "@/modules/Beeswax/beeswax.hook";
import {
  SubModule,
  SubModuleCommonProps,
} from "@/modules/Presets/TargetingExpression/targetingExpression.interface";
import { BasicAutoCompleteItemList } from "@/types";
import { formateDataForCustomSelect } from "@/utils/helpers";
import { Box } from "@mui/material";
import { FieldValues } from "react-hook-form";
import SelectModuleWithType from "../SelectModuleWithType";

const moduleName = "environment";
export default function Environment<
  T extends FieldValues,
  U extends SubModule = "ENVIRONMENT"
>({
  control,
  errors,
  setValue,
  getValues,
  parentName,
  adPosition,
  adPositionLoading,
  environmentTypes,
  environmentTypesLoading,
  isEdit,
}: EnvironmentProps<T, U>) {
  const {
    data: localAdPosition,
    isLoading: localAdPositionLoading,
    isFetching: localAdPositionFetching,
  } = useBeeswaxAdPosition({
    options: {
      enabled: !adPosition && !adPositionLoading,
    },
  });
  const {
    data: localEnvironmentTypes,
    isLoading: localEnvironmentTypesLoading,
    isFetching: localEnvironmentTypesFetching,
  } = useBeeswaxEnvironmentTypes({
    options: {
      enabled: !environmentTypes && !environmentTypesLoading,
    },
  });

  adPosition = isEdit && adPosition ? adPosition : localAdPosition;
  adPositionLoading =
    isEdit && adPosition
      ? adPositionLoading
      : localAdPositionLoading && localAdPositionFetching;

  environmentTypes =
    isEdit && environmentTypes ? environmentTypes : localEnvironmentTypes;

  environmentTypesLoading =
    isEdit && environmentTypes
      ? environmentTypesLoading
      : localEnvironmentTypesLoading && localEnvironmentTypesFetching;
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        height: "100%",
        overflow: "auto",
        padding: 2,
      }}
    >
      <SelectModuleWithType
        itemList={formateDataForCustomSelect(
          adPosition?.results,
          "name",
          "id"
        )?.map((item: Record<string, string | number>) => ({
          ...item,
          value: String(item.value),
        }))}
        control={control}
        errors={errors}
        name={`${parentName}.${moduleName}.ad_position`}
        label="Ad Position"
        setValue={setValue}
        getValues={getValues}
        loading={adPositionLoading}
      />
      <SelectModuleWithType<T>
        itemList={formateDataForCustomSelect(
          environmentTypes?.results,
          "name",
          "id"
        )?.map((envType: BasicAutoCompleteItemList) => {
          return {
            ...envType,
            value: String(envType.value),
          };
        })}
        control={control}
        errors={errors}
        name={`${parentName}.${moduleName}.environment_type`}
        label="Environment Type"
        setValue={setValue}
        getValues={getValues}
        loading={environmentTypesLoading}
      />
    </Box>
  );
}

type EnvironmentProps<T extends FieldValues, U> = U extends "ENVIRONMENT"
  ? Environment<T>
  : never;
interface Environment<T extends FieldValues> extends SubModuleCommonProps<T> {
  adPosition: any;
  adPositionLoading: boolean;
  environmentTypes: any;
  environmentTypesLoading: boolean;
}
